export enum SubscriptionError {
    Valid = 1,
    Expired = 2,
    Invalid = 3,
    NoSubscription = 4,
    Error = 5,
}